<template>
  <v-menu
    ref="menuDatePicker"
    v-model="menuDatePicker"
    :close-on-content-click="false"
    :return-value.sync="selectDate"
    transition="scale-transition"
    offset-y
    max-width="290px"
    min-width="auto"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        outlined
        width="100px"
        v-model="labelDate"
        prepend-inner-icon="mdi-calendar"
        readonly
        v-bind="attrs"
        v-on="on"
        class="input-center"
        :disabled="isDisabled"
        hide-details
        dense
      ></v-text-field>
    </template>
    <v-date-picker
      v-model="selectDate"
      type="month"
      locale="th"
      no-title
      scrollable
      :header-date-format="$helper.headerDateFormat"
      :year-format="$helper.yearFormat"
      :weekday-format="$helper.formatWeekday" :month-format="$helper.formatMonth"
      @input="isOnChange ? onSelectDate():()=>{}"
    >
      <v-spacer></v-spacer>
      <v-btn text color="default" @click="menuDatePicker = false" v-if="!isOnChange">{{ $t('cancel') }}</v-btn>
      <v-btn text color="primary" @click="onSelectDate();" v-if="!isOnChange">{{ $t('confirm') }}</v-btn>
    </v-date-picker>
  </v-menu>
</template>
<script>
export default {
  name: "SelectMonthYear",
  emits: ["onSelect"],
  props: {
    startMonth: Number,
    startYear: Number,
    isDisabled: Boolean,
    isOnChange: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      marketId: null,
      selectDate: null,
      menuDatePicker: false
    };
  },
  created() {
    if (this.startMonth && this.startYear) {
      this.selectDate = `${this.startYear}-${this.$helper.FormatNumberLength(
        this.startMonth,
        2
      )}`;
    } else {
      this.selectDate = new Date().toISOString().substr(0, 7);
    }
    let mm = this.$moment(this.selectDate, "YYYY/MM");
    let dateSelected = {
      name: this.labelDate,
      year: mm.year(),
      month: mm.month() + 1
    };
    this.$emit("onSelect", dateSelected);
  },
  computed: {
    labelDate() {
      return `${this.$moment(this.selectDate, "YYYY/MM").format(
        "MMMM"
      )} / ${this.$moment(this.selectDate, "YYYY/MM").year()}`;
    }
  },
  methods: {
    onSelectDate() {
      this.$refs.menuDatePicker.save(this.selectDate);
      this.menuDatePicker = false;
      let mm = this.$moment(this.selectDate, "YYYY/MM");
      let dateSelected = {
        name: this.labelDate,
        year: mm.year(),
        month: mm.month() + 1
      };
      this.$emit("onSelect", dateSelected);
    }
  }
};
</script>
